import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import customConfig from "./custom-config";
import config from "./amplifyconfiguration.json";

// AWS Amplify configuration
import { Amplify } from "aws-amplify";
import awsExports from "./aws-exports";

// Configure Amplify
Amplify.configure({ ...awsExports, ...config, ...customConfig });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
